import { cn } from '@/lib/cn';

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...props }: DivProps) {
  return (
    <div
      className={cn(
        // 21-oct, macOS 27: tarjeta agrupada plana (#F7F7F7 / #252525), radio 12, sin filo ni sombra.
        'rounded-lg bg-surface-muted',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: DivProps) {
  return <div className={cn('flex flex-col gap-1 border-b border-surface-border p-4 dark:border-white/10', className)} {...props} />;
}

export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('text-base font-semibold text-slate-900 dark:text-slate-100', className)} {...props} />;
}

export function CardDescription({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-sm text-slate-500 dark:text-slate-400', className)} {...props} />;
}

export function CardBody({ className, ...props }: DivProps) {
  return <div className={cn('p-4', className)} {...props} />;
}

export function CardFooter({ className, ...props }: DivProps) {
  return <div className={cn('flex items-center gap-2 border-t border-surface-border p-4 dark:border-white/10', className)} {...props} />;
}
